// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.oasys-wallet",
    name: "Oasys Passport",
    homepage: "https://www.oasys-wallet.com/",
    image_id: "43eb1fb9-e0db-4c9b-d864-4d7fc5abcc00",
    app: {
        browser: null,
        ios: "https://apps.apple.com/jp/app/oasys-passport/id6449960854",
        android: "https://play.google.com/store/apps/details?id=com.oasys_wallet.oas_app",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "oasys-wallet://",
        universal: "https://www.oasys-wallet.com/wc/",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map